// import TimerIcon from '@material-ui/icons/Timer';
import { Refresh } from "@mui/icons-material";
import React from "react";
import { useState, useEffect } from "react";
import { MdTimer } from "react-icons/md";

const Timer = (props) => {
  const { initialMinute = 0, initialSeconds = 0, apicallSendCode } = props;
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const handleRefresh = () => {
    props.handleClickAgain();
    setMinutes(2);
    setSeconds(0);
    apicallSendCode("refresh");
  };

  return (
    <>
      {minutes === 0 && seconds === 0 && (
        <div
          style={{
            backgroundColor: "#FFF",
            width: 130,
            height: 41,
            borderRadius: 5,
            cursor: "pointer",
            margin: "0 auto",
          }}
          className="flex justify-center items-center"
        >
          <div
            className="flex justify-center text-xs"
            onClick={() => handleRefresh()}
          >
            <div className="text-primary" style={{ margin: 0, marginLeft: 2 }}>
              <Refresh style={{ marginLeft: 4 }} />
              {"ارسال مجدد کد"}
            </div>
          </div>
        </div>
      )}
      {minutes !== 0 || seconds !== 0 ? (
        <div
          style={{
            backgroundColor: "#FFF",
            width: 67,
            height: 41,
            borderRadius: 5,
            margin: "0 auto",
          }}
          className="flex justify-center items-center"
        >
          <div className="flex items-center" style={{ color: "#CCC" }}>
            <MdTimer className="mb-1" style={{ fontSize: "16" }} />
            <span className="mr-1" style={{ margin: 0 }}>
              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Timer;
